export const res = {
  back: {
    is: 'Til baka',
    en: 'Back',
    pl: 'Wróć',
  },
  confirm: {
    is: 'Samþykkja',
    en: 'Approve',
    pl: 'Zatwierdź',
  },
  cancel: {
    is: 'Hætta við',
    en: 'Cancel',
    pl: 'Anuluj',
  },
  continue: {
    is: 'Áfram',
    en: 'Continue',
    pl: 'Kontynuuj',
  },
  loadingTitle: {
    is: 'Augnablik',
    en: 'One moment',
    pl: 'Proszę czekać',
  },
};
